// Lấy thông tin User từ localStorage
export const getUserInfo = () => {
  const info = localStorage.getItem("user_info");
  return info ? JSON.parse(info) : null;
};

// Kiểm tra Role (Admin/User)
export const hasRole = (roles) => {
  const user = getUserInfo();
  if (!user) return false;
  
  // Nếu roles là mảng ['admin', 'user'] thì kiểm tra có nằm trong đó không
  if (Array.isArray(roles)) {
    return roles.includes(user.role?.toLowerCase());
  }
  
  // Nếu roles là chuỗi đơn 'admin'
  return user.role?.toLowerCase() === roles.toLowerCase();
};

// Kiểm tra quyền truy cập dữ liệu theo Cơ sở (Facility)
// Dùng khi muốn biết User này có được phép sửa/xóa hồ sơ này không
export const canAccessData = (dataFacilityId) => {
  const user = getUserInfo();
  if (!user) return false;
  
  // Admin hệ thống thường có quyền xem tất cả (hoặc bạn có thể chặn tùy ý)
  if (user.role?.toLowerCase() === 'admin') return true;
  
  // User thường chỉ được chạm vào dữ liệu trùng mã cơ sở
  return parseInt(user.facility_id) === parseInt(dataFacilityId);
};

// Hàm Logout sạch sẽ
export const logout = () => {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("user_info");
  window.location.href = "/login";
};